/// <reference path="../_all.ts" />

module part {

  ProductBoxDirective.$inject = ['pageMetaService',];
  export function ProductBoxDirective(pageMetaService: navigation.IPageMetaService): ng.IDirective {


    return {
      restrict: 'E',
      scope: {  
        product: '=',  
        pictures: '=',  
        showAsLine: '=', 
      },
      templateUrl: 'part/ProductBoxDirective',  
      link: function (scope: any, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {        
        scope.meta = pageMetaService.getPageMeta;
      }
    }
  }

}